import RouteHeader from "../../Components/dispatching-planning/common/RouteHeader";
import React from "react";
import LiteVersionCreateWaypointForm from "./LiteVersionCreateWaypointForm";
import LiteVersionRoutingOptions from "./LiteVersionRoutingOptions";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const LiteVersionMiddleColumn = ({ routeId }: { routeId: string }) => {
  const { t } = useTranslation("dispatching");
  return (
    <div>
      <Typography sx={{ mt: 2 }} variant="h2">
        {t("liteVersion.routeVehicleHeading")}
      </Typography>
      <div className="mt-2">
        <div className="text-gray-500 mb-2">{t("liteVersion.vehicle")}</div>
        <RouteHeader routeId={routeId} />
      </div>
      <br />
      <Typography sx={{ mt: 2 }} variant="h2">
        {t("liteVersion.routingOptions")}
      </Typography>
      <div className="mt-2">
        <div className="text-gray-500 mb-2">
          {t("liteVersion.configureRoute")}
        </div>
        <LiteVersionRoutingOptions />
      </div>
      <br />
      <Typography sx={{ mt: 2 }} variant="h2">
        {t("liteVersion.addWaypointHeader")}
      </Typography>
      <br />
      <LiteVersionCreateWaypointForm routeId={routeId} />
    </div>
  );
};

export default LiteVersionMiddleColumn;
